import React from 'react';
import ReportFrame from '../ReportFrame';

export default class AssignmentFeeRevenueByIndustry extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ReportType']}
          reportName='Revenue Metrics - Assignment Fee Revenue By Industry'
          reportParams={reportParams}
          id='assignmentfeerevenuebyindustry'
          name='assignmentfeerevenuebyindustry'
          title='Assgn. Fee Revenue by Industry'
        />
      </div>
    );
  }
}
